import Model from '@/models/Model'

export default class HrPreviredNationality extends Model {
    resource() {
        return 'hr_previred_nationality'
    }
}